import type { PresalesTaskTemplate } from '@/api/types'

export interface TaskTemplate {
  value: PresalesTaskTemplate
  label: string
  defaultDescription: string
  hasContext: boolean
}

export const TASK_TEMPLATES: TaskTemplate[] = [
  {
    value: 'create_v1_uat',
    label: 'Create V1 UAT account',
    defaultDescription: 'Create V1 UAT account',
    hasContext: false,
  },
  {
    value: 'create_v2_uat',
    label: 'Create V2 UAT account',
    defaultDescription: 'Create V2 UAT account',
    hasContext: false,
  },
  {
    value: 'send_v1_invite',
    label: 'Send V1 UAT account invite email',
    defaultDescription: 'Send V1 UAT account invite email',
    hasContext: false,
  },
  {
    value: 'send_v2_invite',
    label: 'Send V2 UAT account invite email',
    defaultDescription: 'Send V2 UAT account invite email',
    hasContext: false,
  },
  {
    value: 'portal_invite_sent',
    label: 'Portal invite sent',
    defaultDescription: 'Send portal invite',
    hasContext: false,
  },
  {
    value: 'api_key_sent',
    label: 'API key sent',
    defaultDescription: 'Send API key',
    hasContext: false,
  },
  {
    value: 'postman_collection_sent',
    label: 'Postman collection sent',
    defaultDescription: 'Send Postman collection',
    hasContext: false,
  },
  {
    value: 'test_guide_sent',
    label: 'Test guide sent',
    defaultDescription: 'Send test guide',
    hasContext: false,
  },
  {
    value: 'answer_question',
    label: 'Answer question',
    defaultDescription: 'Answer question',
    hasContext: true,
  },
  {
    value: 'custom_work',
    label: 'Custom Work',
    defaultDescription: '',
    hasContext: true,
  },
  {
    value: 'setup',
    label: 'Setup',
    defaultDescription: '',
    hasContext: true,
  },
  {
    value: 'other',
    label: 'Other (free text)',
    defaultDescription: '',
    hasContext: false,
  },
]
